export enum EAlertTypes {
	Success = 'success',
	Danger = 'danger',
}
